import React from 'react';
import PropTypes from 'prop-types';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { TextField } from 'formik-material-ui';
import { connect } from 'react-redux';
import FormDialog from '../../FormDialog';
import hasPermission from '../../../selectors/hasPermission';

const initialValue = {
  tracking_number: undefined,
  custom_shipping_fee: undefined,
  internal_shipping_cost: undefined
};

const validationSchema = {
  tracking_number: Yup.string().required('Required'),
  custom_shipping_fee: Yup.number()
    .nullable()
    .min(0, 'Value cannot be less than zero')
    .typeError('Please enter a valid number'),
  internal_shipping_cost: Yup.number()
    .nullable()
    .min(0, 'Value cannot be less than zero')
    .typeError('Please enter a valid number')
};

export const PrintCompletionDialog = ({
  onContinue,
  onClose,
  open,
  fields,
  initialValues,
  excludeFields,
  ...props
}) => {
  const visibleFields = fields.filter(field => !excludeFields.includes(field));

  const validation = Yup.object().shape(
    visibleFields.reduce(
      (schema, property) => ({
        ...schema,
        [property]: validationSchema[property]
      }),
      {}
    )
  );

  const mergedInitialValues = {
    ...initialValue,
    ...initialValues
  };

  return (
    <Formik
      validationSchema={validation}
      initialValues={mergedInitialValues}
      onSubmit={onContinue}
      enableReinitialize
    >
      {({ isValid, resetForm, submitForm }) => {
        return (
          <FormDialog
            titleText="Shipping Information"
            acceptButtonText="Continue"
            {...props}
            open={open}
            handleClose={submit => {
              if (submit) {
                submitForm().then(() => {
                  resetForm();
                });
              } else {
                onClose();
                resetForm();
              }
            }}
            isAcceptButtonDisabled={!isValid}
          >
            <Form>
              <Field
                autoFocus
                id="name"
                name="tracking_number"
                label="Tracking Number"
                type="text"
                required
                fullWidth
                component={TextField}
              />
              {visibleFields.includes('custom_shipping_fee') && (
                <Field
                  id="name"
                  name="custom_shipping_fee"
                  label="Override Shipping Fee (Optional)"
                  fullWidth
                  component={TextField}
                />
              )}
              {visibleFields.includes('internal_shipping_cost') && (
                <Field
                  id="name"
                  name="internal_shipping_cost"
                  label="Internal Shipping Cost (Optional)"
                  fullWidth
                  component={TextField}
                />
              )}
            </Form>
          </FormDialog>
        );
      }}
    </Formik>
  );
};

PrintCompletionDialog.propTypes = {
  onContinue: PropTypes.func.isRequired,
  open: PropTypes.bool,
  fields: PropTypes.arrayOf(PropTypes.string).isRequired,
  onClose: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  initialValues: PropTypes.object,
  excludeFields: PropTypes.arrayOf(PropTypes.string)
};

PrintCompletionDialog.defaultProps = {
  open: false,
  initialValues: {},
  excludeFields: []
};

const getAllowedFields = state => {
  const fields = ['tracking_number'];

  if (hasPermission(state, { permissions: ['shipments.manage'] })) {
    fields.push('custom_shipping_fee', 'internal_shipping_cost');
  }

  return fields;
};

export default connect(state => {
  return { fields: getAllowedFields(state) };
})(PrintCompletionDialog);
